import type { Feature } from '@luna/gatekeeper';

export const changeCardDelivery: Feature = {
    enabled: false,
    _description: 'Displays the refactored card change delivery focus page',
};
